import { useTranslation } from 'next-i18next';

import { useSubmitForm } from '../../client-queries/form';

import type { ContactFormValues } from './index';

export const useFormSubmit = () => {
  const { t } = useTranslation('common');

  const successToast = {
    title: t('toast.success.title'),
    description: t('toast.success.description'),
  };

  const errorToast = {
    title: t('toast.error.title'),
    description: t('toast.error.description'),
  };

  const {
    mutate: submitForm,
    isLoading: isSubmitting,
    isSuccess,
    reset,
  } = useSubmitForm({
    toasts: { success: successToast, error: errorToast },
  });

  const onSubmit = (values: ContactFormValues) => {
    submitForm(values);
  };

  return { onSubmit, isSubmitting, isSuccess, reset };
};
